import React from 'react';

import { useDeviceTypeIsMobile } from '@/hooks';

import { MobileContainer } from './MobileContainer';
import { DesktopContainer } from './DesktopContainer';

const Welcome = ({ landingToMobile }: { landingToMobile?: boolean }) => {
  const isMobile = useDeviceTypeIsMobile();

  return isMobile ? <MobileContainer landingToMobile={landingToMobile} /> : <DesktopContainer />;
};

export default Welcome;
